import { bindActionCreators, Dispatch } from 'redux';
import { connect } from 'react-redux';
import NewRecipe from './presenter';
import Types from 'Types';
import { createRecipe } from 'src/state/recipe/actions';

interface State {

}

const mapStateToProps = (state: Types.RootState, ownProps: State) => ({
});

const mapDispatchToProps = (dispatch: Dispatch<Types.RootAction>) => bindActionCreators({
  createRecipe: createRecipe.request
}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NewRecipe);